import { useEffect, useState } from "react";

const HealthCheck = () => {
  const [loading, setLoading] = useState(true);
  const [apiServiceIsAvailable, setApiServiceIsAvailable] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/hc`) // change this to your actual API
      .then((res) => {
        if (res?.status === 200) {
          setApiServiceIsAvailable(true);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <div dir="ltr" className="bg-dark text-white p-2 h-screen ">
      loading ...
      </div>
    );

  return (
    <pre
      dir="ltr"
      className="h-screen bg-dark text-white overflow-y-scroll p-2"
    >
      Backend Service:
      {apiServiceIsAvailable ? "true" : "false"}
    </pre>
  );
};

export default HealthCheck;
